import Marionette from 'backbone.marionette';
import { LoadMoreView } from '../../../../core/views/components';
import { Model } from 'backbone';

import {
	TableLayout,
	FullWidth,
	RightSidebar
} from '../../layouts';

import {
	Rounds,
	Squads,
	RankingsCollection,
	Ladder
} from '../../collections';

import {
	RankingsTableTipping,
	RankingsHeaderTipping,
	RankingsTableComp,
	RankingsHeaderComp,
	RankingsHeaderStreak,
	WidgetLadder,
	RankingsTableStreak,
	AdvertisingView
} from '../../views';

import {
	Rankings
} from '../../models';
import { sizes_for_big_ad } from '../../../../core/utils';

export class RankingsController extends Marionette.Object {
	start( table_body, header_page, load_more = true  ) {
		const
			rootView = this.getOption('rootView'),
			tableLayout     = new TableLayout(),
			fullWidthLayout = new FullWidth(),
			advertisingFooter = new AdvertisingView( {
				ad_id:   'tip-entry-ad-slot-2',
				ad_path: 'tip-entry',
				size:    sizes_for_big_ad(),
				pos: 3,
			} );

		tableLayout.getRegion( 'table_body' ).show( table_body );
		tableLayout.getRegion( 'header_page' ).show( header_page );

		if( load_more ) {
			let loadMoreView = new LoadMoreView();
			tableLayout.getRegion( 'load_more' ).show( loadMoreView );
		}

		fullWidthLayout.getRegion( 'content' ).show( tableLayout );

		rootView.getRegion( 'main' ).show( fullWidthLayout );
		rootView.getRegion('top_ads_container').show(advertisingFooter);
	}

	startSidebar( table_body, header_page, load_more = true ) {
		const
			rootView = this.getOption('rootView'),
			tableLayout     = new TableLayout(),
			rightSidebarLayout = new RightSidebar(),
			advertisingSidebar = new AdvertisingView( {
				ad_id:   'competitions-ad-slot-1',
				ad_path: 'competitions',
				size:    [ 300, 250 ],
				pos: 2,
			} ),
			advertisingFooter  = new AdvertisingView( {
				ad_id:   'competitions-ad-slot-2',
				ad_path: 'competitions',
				size:    sizes_for_big_ad(),
				pos: 3,
			} );

		tableLayout.getRegion( 'table_body' ).show( table_body );
		tableLayout.getRegion( 'header_page' ).show( header_page );

		if( load_more ) {
			let loadMoreView = new LoadMoreView();
			tableLayout.getRegion( 'load_more' ).show( loadMoreView );
		}

		rightSidebarLayout.getRegion( 'content' ).show( tableLayout );
		rightSidebarLayout.getRegion( 'widget' ).show( new WidgetLadder({
			model: new Model(),
			collection: new Ladder()
		}) );
		rightSidebarLayout.getRegion('ads_container').show( advertisingSidebar );


		rootView.getRegion( 'main' ).show( rightSidebarLayout );
		rootView.getRegion('top_ads_container').show(advertisingFooter);
	}

	/**
	 * RankingsTipping Tipping page ( rankings/tipping )
	 */
	rankingsTipping() {
		const
			rounds          = new Rounds(),
			model           = new Rankings,
			table_body    = new RankingsTableTipping( {
				collection: new RankingsCollection(),
				squads: new Squads(),
				rounds,
				model
			} ),
			header_page  = new RankingsHeaderTipping( {
				rounds,
				model
			} );

		this.start( table_body, header_page );
	}

	/**
	 * RankingsTipping Tipping page ( rankings/tipping )
	 */
	rankingsComp() {
		const
			rounds          = new Rounds(),
			model           = new Rankings,
			table_body    = new RankingsTableComp( {
				collection: new RankingsCollection(),
				squads: new Squads(),
				rounds,
				model
			} ),
			header_page  = new RankingsHeaderComp( {
				rounds,
				model
			} );

		this.startSidebar( table_body, header_page, false );
	}

	/**
	 * RankingsTipping Tipping page ( rankings/streak )
	 */
	rankingsStreak() {
		const
			rounds          = new Rounds(),
			model           = new Rankings,
			table_body = new RankingsTableStreak({
				rounds,
				model,
				collection: new RankingsCollection()
			}),
			header_page  = new RankingsHeaderStreak( {
				rounds,
				model
			} );

		this.startSidebar( table_body, header_page, false );
	}
}

export default RankingsController;